export enum MarketType {
  Deadline = 0,
  Live = 1,
}

export type Market = {
  id: string;
  creatorId: string;
  title: string;
  rules: string;
  isSettled: boolean;
  isVoid: boolean;
  marketType: MarketType;
  deadline: Date;
  createdAt: Date;
  completedAt?: Date;
  outcomes: Outcome[];
  winningOutcomeId: string | null;
  userIdToPredictions: Record<string, Prediction[]>; // Only contains filtered user's predictions or all if filterUser=address(0)
  totalPredictionsCount: number; // Total count stored in contract, incremented on each prediction
  minPredictionAmount: bigint;
  feeBps: bigint;
  totalsPerOutcome: Record<string, number>; // Total volume per outcome from contract
  totalSharesPerOutcome: Record<string, bigint>; // Total shares per outcome from contract (for Live markets)
  creatorFeesTotal: number; // Total creator fees earned on this market (pre-calculated by contract for settled markets)
};

export type Prediction = {
  id: string;
  marketId: string;
  userId: string;
  outcomeId: string;
  amount: number;
  shares: bigint;
  createdAt: number;
};

export type Outcome = {
  id: string;
  name: string;
  probability: number; // as a percentage
  odds: number; // as a multiplier (e.g., 2.5 means you win 2.5x your bet if this outcome occurs)
  chance: number; // the percentage version of odds (e.g., 40 means 40% chance of winning)
  volume: number; // total amount wagered
};

export type OutcomeInput = {
  name: string;
  probability: number;
};

export type CreatorDetails = {
  id: string;
  address: string;
  nickname: string;
  streamUrl: string;
  description: string;
  logoUrl?: string; // Optional: URL to creator's logo (from blob storage)
};

export type CreatorStats = {
  activeMarketsCount: number;
  totalVolume: number; // Total tokens staked across all markets
  totalEarnings: number; // Total fees earned from settled markets
  totalSettledMarkets: number; // Total number of settled markets
  totalPredictionsCount: number; // Total number of predictions across all markets
  lastActivityTimestamp: number; // Timestamp of most recent market activity (0 if no activity)
};

export type PredictionWithMarket = {
  market: Market;
  prediction: Prediction;
};

export type CreatorCounts = {
  all: number;
  live: number;
  pending: number;
  settled: number;
};

export type ContractConfig = {
  maxTime: number;
  platformFees: bigint;
  minCreatorFees: number;
  maxCreatorFees: number;
  minPredictionAmount: bigint;
  predictionCurrency: string;
  affiliateFeePercentage: number;
  lowestPossibleOdds: bigint;
  virtualLiquidityMultiplier: number;
};

export type MarketListener = (market: Market) => void;
